import { RicosViewer } from 'ricos-viewer-next';
import { createWixRicosViewer } from './WixRicosViewerNext';
export * from '@wix/ricos-common';
export const WixRicosViewer = createWixRicosViewer(RicosViewer);
//# sourceMappingURL=index.js.map